import { Typography } from "@mui/material";

export const SmsModalTitle = () => {
  return <Typography variant="h4">Envoi d'un SMS au(x) candidat(s)</Typography>;
};
